import { ref, watch } from 'vue';
import useAxiosAPI from '@global/composable/api/useAxiosAPI';
import useModalStore from '@global/stores/useModalStore';

const { getRefundDetailAPI } = useAxiosAPI();

const modalStore = useModalStore();
const { closeModal } = modalStore;

function useRefundDetail(props) {
  const data = ref([]);
  const dataIsLoad = ref(false);

  function fetchAPI() {
    getRefundDetailAPI(
      {
        params: {
          TransactionID: props.transactionId,
        },
      },
    )
      .then((res) => {
        if (res.data.Code === 200) {
          data.value = res.data.Response;
          dataIsLoad.value = true;
        } else {
          closeModal();
        }
      })
      .catch((error) => {
        console.log(error);
        closeModal();
      });
  }

  return {
    data,
    dataIsLoad,
    fetchAPI,
  };
}

export default useRefundDetail;
